/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './share-button.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from 'ng2share/share-button/share-button.component';
import * as i3 from '@angular/common';
const styles_ShareButtonComponent:any[] = [i0.styles];
export const RenderType_ShareButtonComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_ShareButtonComponent,data:{}});
function View_ShareButtonComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),7,'span',[['class',
      'n2s-shareText']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n                  '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),1,'span',[['class','n2s-shareText-primary']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['',' '])),(_l()(),i1.ɵted((null as any),['\n                  '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),1,'span',[['class','n2s-shareText-secondary']],
              (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['',''])),(_l()(),i1.ɵted((null as any),['\n                ']))],
      (null as any),(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.platform.text;
        _ck(_v,3,0,currVal_0);
        const currVal_1:any = _co.addedText;
        _ck(_v,6,0,currVal_1);
      });
}
export function View_ShareButtonComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),9,'a',[['target',
      '_blank']],[[8,'href',4]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i2.ShareButtonComponent = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.click($event)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n              '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),6,'div',([] as any[]),[[8,'className',
          0]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i2.ShareButtonComponent = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.click($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n                '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),0,'i',([] as any[]),[[8,'className',
          0]],(null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_ShareButtonComponent_1)),i1.ɵdid(16384,(null as any),
          0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n              '])),(_l()(),i1.ɵted((null as any),
          ['\n            '])),(_l()(),i1.ɵted((null as any),['\n            ']))],
      (_ck,_v) => {
        var _co:i2.ShareButtonComponent = _v.component;
        const currVal_3:any = _co.textEnabled;
        _ck(_v,7,0,currVal_3);
      },(_ck,_v) => {
        var _co:i2.ShareButtonComponent = _v.component;
        const currVal_0:any = i1.ɵinlineInterpolate(1,'',_co.url,'');
        _ck(_v,0,0,currVal_0);
        const currVal_1:any = i1.ɵinlineInterpolate(3,'n2s-share-btn n2s-share-btn-',
            _co.platform.name,' n2s-',_co.direction,'-margin\n                  ',
            (_co.textEnabled? 'n2s-share-btn-with-text': ''),'');
        _ck(_v,2,0,currVal_1);
        const currVal_2:any = i1.ɵinlineInterpolate(1,'ic fa fa-',_co.platform.logoOfficial,
            '');
        _ck(_v,4,0,currVal_2);
      });
}
export function View_ShareButtonComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'share-button',
      ([] as any[]),(null as any),(null as any),(null as any),View_ShareButtonComponent_0,
      RenderType_ShareButtonComponent)),i1.ɵdid(114688,(null as any),0,i2.ShareButtonComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ShareButtonComponentNgFactory:i1.ComponentFactory<i2.ShareButtonComponent> = i1.ɵccf('share-button',
    i2.ShareButtonComponent,View_ShareButtonComponent_Host_0,{platformName:'platformName',
        textEnabled:'textEnabled',addedText:'addedText',direction:'direction',properties:'properties'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Users/Yi-Yu/Documents/Actual Documents/Katiso/katiso/src/$$_gendir/node_modules/ng2share/share-button/share-button.component.ngfactory.ts